import { Box, Button, Grid2, } from '@mui/material'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { CustomIconButton } from '../../shared/utils/IconButton';
import { Form_Padding, Grid_Gap, Input_Width, Input_Width_LG } from '../../shared/constants';
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import { PhoneInputFormField } from '../../shared/components/formfields/PhoneInputFormField';
import useAuthStore from '../../store/useAuthStore';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LocationSelectorField } from '../../shared/components/LocationSelectorField';
import CustomDivider from '../../shared/utils/CustomDivider';
import { putSchoolProfile } from '../../assets/nodeApi/putApi/putSchoolApi';
import { FormSkeleton } from '../../shared/utils/SkeletonCom';
import { setCookie } from '../../shared/utils/CookieUtils';
import { useGetUserDetail } from '../../assets/api/UseStudentGetApi';

const SchoolDetailForm = ({ onClose }) => {
    const queryClient=useQueryClient()
    const { data, isLoading } = useGetUserDetail()
    const setUser = useAuthStore((state) => state.setUser);
    const userDetail = data?.data
    
    const { showToaster } = useToaster();

    const validationSchema = yup.object().shape({});

    const initialValues = {
        lastname: userDetail?.lastname || "",
        city: userDetail?.city || "",
        address: userDetail?.address || "",
        country_name: userDetail?.country_name || "",
        state: userDetail?.state || "",
        zip: userDetail?.zip || "",
        firstname: userDetail?.firstname || "",
        email: userDetail?.email || "",
        mobile: userDetail?.mobile || "",

    };

    const mutation = useMutation({
        mutationFn: putSchoolProfile,
    });

    const handleSubmit = (values, { resetForm }) => {
        const { undefined, ...payload } = values;
        mutation.mutate(payload, {
            onSuccess: (response) => {
                queryClient.invalidateQueries({ queryKey: ["user/details"] });
                showToaster('success', response?.message, 'success')
                setUser(response.data);
                setCookie("user", response.data);
                resetForm()
            },
            onError: (err) => {
                console.error(err)
                showToaster('Error occurred while submitting Form.', 'Error', 'error')
            },
        });
    };

    return (
        <>
            <Box >
                <Box sx={{ p: Form_Padding, bgcolor: "blue.main", position: "relative", minBlockSize: "80px" }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <CustomIconButton icon={<KeyboardBackspaceIcon style={{ color: "#fff" }} fontSize='26px' />} onClick={() => { onClose() }} />
                    </Box>
                </Box>
                <Box sx={{ p: Form_Padding, mt: "80px" }}>
                    {isLoading &&
                        <Grid2 container spacing={Grid_Gap}>
                            {
                                [...Array(10)].map((_, index) => (
                                    <Grid2 children size={Input_Width_LG} key={index}>
                                        <FormSkeleton height={40} />

                                    </Grid2>
                                ))
                            }

                        </Grid2>
                    }

                    {
                        !isLoading &&
                        <Formik initialValues={initialValues} enableReinitialize={true} validationSchema={validationSchema} onSubmit={handleSubmit}>
                            {({ resetForm }) => (
                                <Form>
                                    <Grid2 container spacing={Grid_Gap}>

                                        <Grid2 children size={Input_Width_LG}>
                                            <Field
                                                name="firstname"
                                                component={TextFormField}
                                                label="First Name"
                                                isRequired={true}
                                            />
                                        </Grid2>
                                        <Grid2 children size={Input_Width_LG}>
                                            <Field
                                                name="lastname"
                                                component={TextFormField}
                                                label="Last Name"
                                                isRequired={false}
                                            />
                                        </Grid2>
                                        <Grid2 children size={Input_Width_LG}>
                                            <Field
                                                name="email"
                                                component={TextFormField}
                                                label="Email"
                                                isRequired={true}
                                                disabled
                                            />
                                        </Grid2>
                                        <Grid2 children size={Input_Width_LG}>
                                            <Field
                                                name="mobile"
                                                component={PhoneInputFormField}
                                                label="mobile"
                                                isRequired={true}
                                                disabled={true}
                                            />
                                        </Grid2>
                                        <LocationSelectorField
                                            countryField="country_name"
                                            stateField="state"
                                            cityField="city"
                                            isStoredId={false}
                                            Input_Width={Input_Width_LG}
                                            isProfile={true}
                                            zipField={"zip"}
                                            userDetail={userDetail}
                                            passedCityId={userDetail?.city_id}
                                            passedStateId={userDetail?.state_id}
                                            passedCountryId={userDetail?.country_id}
                                        />

                                        <Grid2 children size={Input_Width_LG}>
                                            <Field
                                                name="address"
                                                component={TextFormField}
                                                label="Address"
                                                isRequired={true}
                                            />
                                        </Grid2>
                                    </Grid2>
                                    <CustomDivider />
                                    <Grid2 container spacing={Grid_Gap}>
                                        <Grid2 children size={Input_Width} >
                                            <Button variant='outlined' fullWidth onClick={() => { resetForm() }}
                                                disabled={mutation.isPending}
                                            >Cancel</Button>
                                        </Grid2>
                                        <Grid2 children size={Input_Width}>
                                            <Button variant='contained' fullWidth type="submit" disabled={mutation.isPending}>
                                                {mutation.isPending ? "Submitting..." : "Submit"}
                                            </Button>
                                        </Grid2>
                                    </Grid2>
                                </Form>
                            )}
                        </Formik>
                    }

                </Box>
            </Box>
        </>
    )
}

export default SchoolDetailForm
